import styled from "styled-components";

export const Styled = styled.div`
  overflow: auto;
  height: 100%;

  .header {
    padding: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--Grey-10, #f5f5f5);

    .entity-container {
      display: flex;
      flex-direction: column;

      .entity-timestamp {
        color: var(--Grey-70, var(--Grey-70, #757576));
        font-size: var(--font-size-xs, 12px);
        line-height: var(--font-line-height-xs, 16px);
      }
    }
  }

  .log-details-table {
    width: 100%;
    border-collapse: collapse;
    border-radius: 20px;
    table-layout: fixed;

    .table-header tr {
      background: var(--color-gray-100, #e2e3e5);

      th {
        padding: 12px 0;
        text-align: left;
        color: var(--color-gray-600, #4d4e54);
        font-size: var(--font-size-xs, 12px);
        font-weight: 900;
        line-height: var(--font-line-height-xs, 16px); /* 133.333% */
        letter-spacing: var(--font-letter-spacing-10, 1.2px);
        text-transform: uppercase;
        word-wrap: break-word;
        overflow-wrap: break-word;

        &:first-child {
          padding-left: 16px;
          width: 25%;
        }

        &:nth-child(2) {
          width: 37.5%;
        }

        &:last-child {
          padding-right: 16px;
          width: 37.5%;
        }

        /* For 2-column layout (create/delete actions) */
        &:only-child {
          width: 75%;
        }

        &:nth-child(2):last-child {
          width: 75%;
        }
      }
    }

    tbody {
      .td-key,
      .td-before-general,
      .td-after-general,
      .td-value {
        border: 1px solid var(--color-gray-100, #e2e3e5);
        padding: 16px 20px;
        vertical-align: top;
        font-size: var(--font-size-sm, 14px);
        line-height: var(--font-line-height-sm, 20px);
        color: var(--color-gray-950, #19191b);
        word-wrap: break-word;
        overflow-wrap: break-word;

        &:first-child {
          border-left: none;
          color: var(--color-foreground, #404145);
          font-weight: 700;
          width: 25%;
        }

        &:nth-child(2) {
          width: 37.5%;
        }

        &:last-child {
          border-right: none;
          width: 37.5%;
        }

        /* For 2-column layout (create/delete actions) */
        &:nth-child(2):last-child {
          width: 75%;
        }
      }

      .td-key {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .td-json-diff {
        padding: 0;
      }
    }
  }

  pre {
    margin: 0;
    font-family: "Fira Code";
    font-size: 13px;
    line-height: 20px;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  /* react-diff-viewer */
  [class*="css-"][class*="-diff-container"] pre {
    font-family: "Fira Code";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    span {
      font-family: "Fira Code", monospace;
    }
  }
`;
